import { compose, subtract } from 'ramda';

const removeEmptyStrings = arg => {
  if (typeof arg === 'string') {
    return arg.length > 0;
  }
  return true;
};

export const classnames = (...args) => {
  const className = [];
  args.filter(removeEmptyStrings).forEach(arg => {
    if (typeof arg === 'string') {
      className.push(arg);
    } else {
      Object.keys(arg)
        .filter(key => Boolean(arg[key]))
        .forEach(key => {
          className.push(key);
        });
    }
  });

  return className.join(' ');
};

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});

export const makePositive = Math.abs;
export const makeNegative = compose(subtract(0), makePositive);

export const IsServerSideRendering = (function serverSideRenderCheck() {
  try {
    return typeof window === 'undefined';
  } catch (e) {
    return true;
  }
})();
